import React, { useEffect } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useFormikContext } from 'formik';
import { compose } from 'redux';

// GLOBAL VARIABLES
import { NUMBER_FORMATS } from 'numberFormats.js';

// GLOBAL FUNCTIONS
import { bugLog } from 'functions.js';

// LOCAL HELPERS
import { dateValidation } from '../helpers/dateValidation';

// LOCAL CCOMPONENTS
import Calendar from './calendar/Calendar';
import MultiValue from './MultiValue';
import Select from '../../select/Select';
import { COMPONENTS } from '../../select/components/Components';

// STYLES
import styles from '../date.module.scss';

// VARIABLES
const OPTIONS = [0] // This is needed to trick react-select into showing the menu.

// MAIN COMPONENT
const DatePicker = compose(
  dateValidation
)(({
  name,
  currentDate,
  startDate,
  endDate,
  minDate,
  maxDate,
  onSelect,
  allowCustom,
  validationSchema,
  debug,
  ...props
}) => {

  const { setFieldValue } = useFormikContext() || {};

  useEffect(
    () => {
      if (!name) return;
      bugLog('setDummy', debug, name, currentDate);
      setFieldValue(name, currentDate)
    },
    [name, currentDate, setFieldValue, debug]
  )

  return (
  <Select
    name={name}
    className={styles.select}
    value={currentDate}
    placeholder={NUMBER_FORMATS.date.placeholder}
    append={{
      use: 'calendar'
    }}
    options={OPTIONS}
    onSelect={onSelect}
    allowCustom
    validationSchema={validationSchema}
    components={{
      Menu: ({ className, ...props }) => <COMPONENTS.Menu className={clsx(styles.menu, className)} {...props} />,
      MenuList: ({ children, className, ...props }) => (
        <COMPONENTS.MenuList  className={clsx(styles.menuList, className)} {...props}>
          <Calendar
            currentDate={currentDate}
            startDate={startDate}
            endDate={endDate}
            minDate={minDate}
            maxDate={maxDate}
            {...props}
          />
        </COMPONENTS.MenuList>
      ),
      MultiValue,
    }}
    selectProps={{
      validationSchema
    }}
    debug={debug}
    {...props}
  />
)})

// EXPORT
export default DatePicker;
